import { sendBugsnagError } from "@utils/Bugsnag";
import { errorResponseMessage } from "./errorResponseMessage";
import { isSchemaError } from "./isSchemaError";
import { SET_RECAPTCHA, RESET_RECAPTCHA } from "@constants/accountTypes";
import { defaultAction } from "./defaultAction";

export const initForgotPassword =
  (email, reCaptcha, baseURI) => async (dispatch, getState, api) => {
    try {
      await api.post("v3/customers/password/forgot", {
        customer: { email },
        reCaptcha,
        baseURI
      });
      return "success";
    } catch (error) {
      sendBugsnagError(error, "actions/initForgotPassword");

      let message = errorResponseMessage(error);
      if (isSchemaError(message)) {
        message = "Something went wrong, please refresh the page.";
      }

      return { error: message };
    }
  };

export const resetPasswordAccount =
  (newPassword, oldPassword) => async (dispatch, getState, api) => {
    try {
      await api.put("v3/customers/password/change", {
        customer: { oldPassword, newPassword }
      });
      return "success";
    } catch (error) {
      sendBugsnagError(error, "actions/resetPasswordAccount");
      let message = errorResponseMessage(error);
      if (isSchemaError(message)) {
        message = "Something went wrong, please refresh the page.";
      }
      return { error: message };
    }
  };

export const resetPassword =
  (password, token) => async (dispatch, getState, api) => {
    try {
      await api.put("v3/customers/password/reset", { token, password });
      return "success";
    } catch (error) {
      sendBugsnagError(error, "actions/resetPassword");
      let message = errorResponseMessage(error);
      if (isSchemaError(message)) {
        message = "Something went wrong, please refresh the page.";
      }

      return { error: message };
    }
  };

export const setupRecaptcha =
  ({ eltId, sitekey }) =>
  async (dispatch, getState, api, services) => {
    const { grecaptcha } = await services.getGlobals("grecaptcha");

    grecaptcha.ready(() => {
      grecaptcha.render(document.getElementById(eltId), {
        sitekey,
        callback(data) {
          dispatch(defaultAction(SET_RECAPTCHA, data));
        },
        "expired-callback"() {
          dispatch(defaultAction(RESET_RECAPTCHA));
        }
      });
    });
  };
